import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, FileText, Scale, Globe } from 'lucide-react';
import { CONTACT_EMAIL } from '../utils/constants';

const Compliance = () => {
  return (
    <div className="pt-32 pb-20 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-12"
        >
          <div className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-black text-brand-black uppercase italic tracking-tighter">
              COMPLIANCE <span className="text-brand-orange">& ETHICS.</span>
            </h1>
            <div className="flex items-center gap-4">
              <div className="h-[1px] w-12 bg-brand-orange"></div>
              <p className="text-brand-muted font-black tracking-[0.2em] text-[10px] uppercase">Regulatory Framework // 2026-27</p>
            </div>
          </div>

          <p className="text-brand-muted text-lg font-medium leading-relaxed">
            PKRouteX operates under strict adherence to Indian transport regulations and international industrial safety standards. Our compliance Framework ensures every shipment is secure, legal, and environmentally responsible.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="p-8 bg-slate-50 rounded-[2.5rem] border border-black/5 space-y-4">
              <ShieldCheck className="text-brand-orange" size={40} />
              <h3 className="text-xl font-black text-brand-black uppercase">Statutory Licensing</h3>
              <p className="text-sm text-brand-black/70 font-medium">Full adherence to the Carriage by Road Act, 2007. We maintain all mandatory commercial permits, fitness certificates, and pollution control clearances for our entire fleet.</p>
            </div>

            <div className="p-8 bg-slate-50 rounded-[2.5rem] border border-black/5 space-y-4">
              <FileText className="text-brand-orange" size={40} />
              <h3 className="text-xl font-black text-brand-black uppercase">Tax & GST Clarity</h3>
              <p className="text-sm text-brand-black/70 font-medium">100% G-GST compliant billing. We issue comprehensive E-Way bills for every interstate movement, ensuring smooth transit through all state checkpoints and borders.</p>
            </div>

            <div className="p-8 bg-slate-50 rounded-[2.5rem] border border-black/5 space-y-4">
              <Scale className="text-brand-orange" size={40} />
              <h3 className="text-xl font-black text-brand-black uppercase">Ethical Logistics</h3>
              <p className="text-sm text-brand-black/70 font-medium">Zero-tolerance policy towards overloading and unethical road practices. Our drivers undergo mandatory safety training and background verification.</p>
            </div>

            <div className="p-8 bg-slate-50 rounded-[2.5rem] border border-black/5 space-y-4">
              <Globe className="text-brand-orange" size={40} />
              <h3 className="text-xl font-black text-brand-black uppercase">ESG Standards</h3>
              <p className="text-sm text-brand-black/70 font-medium">We are committed to Environmental, Social, and Governance (ESG) principles by optimizing routes to reduce empty miles and maximizing vehicle fuel efficiency.</p>
            </div>
          </div>

          <section className="space-y-6 border-t border-black/5 pt-12">
            <h2 className="text-2xl font-black text-brand-black">VERIFICATION REQUESTS</h2>
            <p className="text-brand-black/80 font-medium leading-relaxed">Corporate partners requiring detailed audit reports, KYC documents, or safety certifications can request our "Compliance Portfolio" via our official legal channel.</p>
            <div className="bg-brand-black p-8 rounded-3xl flex flex-col md:flex-row justify-between items-center gap-6">
               <p className="text-white font-bold italic tracking-wider">{CONTACT_EMAIL}</p>
               <button className="bg-brand-orange text-white px-8 py-3 rounded-full font-black text-xs uppercase orange-glow transition-all">Request Audit Docs</button>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Compliance;
